export const PATH_HOME = '/';
export const PATH_ABOUT = '/about';
export const PATH_REGISTER = '/registration';
export const PATH_LOG_IN = '/sign-in';
export const PATH_TRADING = '/trading';
